module.exports = __webpack_public_path__ + "img/badge-warning-lg.64832099.svg";